const types = {
  SET_SESSION_ID: "SET_SESSION_ID",
  SET_RATE_PARAM: "SET_RATE_PARAM",
  FETCH_WIDGET_JSON_STARTED: "FETCH_WIDGET_JSON_STARTED",
  FETCH_WIDGET_JSON_SUCCESS: "FETCH_WIDGET_JSON_SUCCESS",
  FETCH_WIDGET_JSON_FAILURE: "FETCH_WIDGET_JSON_FAILURE",
  SELECT_LANGUAGE: "SELECT_LANGUAGE",
  SUBMIT: "SUBMIT",
  NEXT_PAGE: "NEXT_PAGE",
  PREVIOUS_PAGE: "PREVIOUS_PAGE",
  SAVE_FORM_VALUES: "SAVE_FORM_VALUES",
  SAVE_FEEDBACK: "SAVE_FEEDBACK",
  SHOW_MARKPAGE: "SHOW_MARKPAGE",
  CLOSE_MARKPAGE: "CLOSE_MARKPAGE",
  SELECT_MARK: "SELECT_MARK",
  IS_SLI_MULTI_SERVICE: "IS_SLI_MULTI_SERVICE",
  SET_SELECTED_SERVICE: "SET_SELECTED_SERVICE",
  GENERATE_PAGE_COMPONENTS: "GENERATE_PAGE_COMPONENTS",
  RESET_CURRENT_FEEDBACK_SCORE: "RESET_CURRENT_FEEDBACK_SCORE",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  FETCH_IDENTIFICATION_STARTED: "FETCH_IDENTIFICATION_STARTED",
  FETCH_IDENTIFICATION_SUCCESS: "FETCH_IDENTIFICATION_SUCCESS",
  FETCH_IDENTIFICATION_FAILURE: "FETCH_IDENTIFICATION_FAILURE",
  FETCH_SEND_COLLECTED_FEEDBACK_STARTED:
    "FETCH_SEND_COLLECTED_FEEDBACK_STARTED",
  FETCH_SEND_COLLECTED_FEEDBACK_SUCCESS:
    "FETCH_SEND_COLLECTED_FEEDBACK_SUCCESS",
  FETCH_SEND_COLLECTED_FEEDBACK_FAILURE:
    "FETCH_SEND_COLLECTED_FEEDBACK_FAILURE",
  RESET_WIDGET: "RESET_WIDGET",
  ADD_TO_CUSTOM_FORM_VALUES: "ADD_TO_CUSTOM_FORM_VALUES",
  SAVE_RENDERED_COMPONENTS: "SAVE_RENDERED_COMPONENTS",
  UPDATE_CONDITION: "UPDATE_CONDITION",
  SET_IS_ERROR_PAGE: "SET_IS_ERROR_PAGE",
  SET_BUTTONS_DISABLE: "SET_BUTTONS_DISABLE",
  SET_SCROLL: "SET_SCROLL",
};

export default types;
